var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuApps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8046_6288)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8046_6288",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H0V15H15V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8046_6288)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8046_6288",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H0V15H15V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8046_6288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.0625 10.9375H0V13.125C0 13.6223 0.197544 14.0992 0.549175 14.4508C0.900805 14.8024 1.37772 15 1.875 15H4.0625V10.9375Z",
    fill: "url(#paint0_linear_8046_6288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10.9375H10.9375V15H13.125C13.6223 15 14.0992 14.8024 14.4508 14.4508C14.8024 14.0992 15 13.6223 15 13.125V10.9375Z",
    fill: "url(#paint1_linear_8046_6288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.0625 5.46875H0V9.53124H4.0625V5.46875Z",
    fill: "url(#paint2_linear_8046_6288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5.46875H10.9375V9.53124H15V5.46875Z",
    fill: "url(#paint3_linear_8046_6288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.0625 0H1.875C1.37772 0 0.900805 0.197544 0.549175 0.549175C0.197544 0.900805 0 1.37772 0 1.875V4.0625H4.0625V0Z",
    fill: "url(#paint4_linear_8046_6288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53124 10.9375H5.46875V15H9.53124V10.9375Z",
    fill: "url(#paint5_linear_8046_6288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53124 5.46875H5.46875V9.53124H9.53124V5.46875Z",
    fill: "url(#paint6_linear_8046_6288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53124 0H5.46875V4.0625H9.53124V0Z",
    fill: "url(#paint7_linear_8046_6288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 0H10.9375V4.0625H15V1.875C15 1.37772 14.8024 0.900805 14.4508 0.549175C14.0992 0.197544 13.6223 0 13.125 0Z",
    fill: "url(#paint8_linear_8046_6288)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8046_6288",
    x1: 2.03125,
    y1: 10.9375,
    x2: 2.03125,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8046_6288",
    x1: 12.9688,
    y1: 10.9375,
    x2: 12.9688,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8046_6288",
    x1: 2.03125,
    y1: 5.46875,
    x2: 2.03125,
    y2: 9.53124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8046_6288",
    x1: 12.9688,
    y1: 5.46875,
    x2: 12.9688,
    y2: 9.53124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8046_6288",
    x1: 2.03125,
    y1: 0,
    x2: 2.03125,
    y2: 4.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8046_6288",
    x1: 7.5,
    y1: 10.9375,
    x2: 7.5,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8046_6288",
    x1: 7.5,
    y1: 5.46875,
    x2: 7.5,
    y2: 9.53124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8046_6288",
    x1: 7.5,
    y1: 0,
    x2: 7.5,
    y2: 4.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8046_6288",
    x1: 12.9688,
    y1: 0,
    x2: 12.9688,
    y2: 4.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8046_6288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuApps);
export default __webpack_public_path__ + "static/media/Menu-Apps.21df8c5b55e11d0bf788d20aa30382b4.svg";
export { ForwardRef as ReactComponent };